import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {getDeletedAcDatas, hardDeleteAcData, restoreAcData,} from "../../../redux/modules/Ac/action";

class AcTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedAcDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.ac.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const acColumn = [
            {
                name: "Ac",
                path: "name",
                show: true,
            },
            {
                name: "Category",
                path: "category",
                show: true,
                render: (data) => data?.name,
            },
            {
                name: "Freon Type",
                path: "freonType",
                show: true,
                render: (data) => data?.name,
            },
            {
                name: "Brand",
                path: "brand",
                show: true,
                render: (data) => data?.name,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"Ac Category Data"}
                        data={this.props.ac.datas}
                        columns={acColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteAcData(id)}
                        restoreAction={(id) => this.props.restoreAcData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ac: state.ac,
});

const mapDispatchToProps = {
    getDeletedAcDatas,
    hardDeleteAcData,
    restoreAcData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcTrash)
);
